/**
 * EndScreen
 *
 * Victory screen when the player has completed the scenario.
 * Congratulates the player and offers to restart or return to the story list.
 */

import styles from './end-screen.module.css';

export interface EndScreenProps {
  endingMessage: string;
  storyTitle?: string;
  onReturnToMenu: () => void;
  onRestart?: () => void;
}

export function EndScreen({ endingMessage, storyTitle, onReturnToMenu, onRestart }: EndScreenProps): JSX.Element {
  return (
    <div
      className={styles.endScreen}
      role="dialog"
      aria-modal="true"
      aria-labelledby="end-title"
    >
      <div className={styles.endScreenOverlay} aria-hidden="true" />
      <div className={styles.endScreenContent}>
        <div className={styles.endScreenHeader}>
          <p className={styles.victoryBadge} aria-hidden="true">
            Victoire
          </p>
          <h1 id="end-title" className={styles.endScreenTitle}>
            Félicitations !
          </h1>
          {storyTitle && (
            <p className={styles.storyTitle}>{storyTitle}</p>
          )}
        </div>

        <div className={styles.endingMessage} aria-live="polite">
          {endingMessage}
        </div>

        <div className={styles.endScreenActions}>
          {onRestart && (
            <button
              className={styles.restartButton}
              onClick={onRestart}
              aria-label="Recommencer l'aventure depuis le début"
            >
              Recommencer l'aventure
            </button>
          )}
          <button
            className={styles.returnButton}
            onClick={onReturnToMenu}
            aria-label="Retourner à la liste des histoires"
          >
            Retour à la liste des histoires
          </button>
        </div>
      </div>
    </div>
  );
}

